import * as React from "react";
import { PatientFacingRouter } from "../PatientRoutes/PatientFacingRouter";
import { isProduction } from "fe-common/utils/envGetter";
import { getVersion } from "../VersionInfo";
import { styled } from "@mui/material";
import { PatientNewVersionPopOver } from "./PatientNewVersionPopOver";
import { MobileSuggestionZoom } from "../components/demodebug/mobileSuggestionZoom/mobileSuggestionZoom";
import { usePatientFeatureFlags } from "../hooks/usePatientFeatureFlags";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

//region [[ Styles ]]
const Footer = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  fontSize: "10px",
  lineHeight: "10px",
  height: "15px",
  position: "fixed",
  bottom: "env(safe-area-inset-bottom)",
  left: 0,
  width: "100vw",
  background: "transparent",
}));
//endregion [[ Styles ]]

//region [[ Props ]]

export interface PatientContentProps {
  embedded?: boolean;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

/***
 * Render content under the context object to have access to the state
 * @param props
 * @constructor
 */
export const PatientContent = ({ embedded, ...props }: PatientContentProps) => {
  const currentVersion = getVersion();

  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down("xs"), { noSsr: true });

  const useDemoPane = usePatientFeatureFlags("demoPane") && !isMobile;

  return (
    <>
      <PatientNewVersionPopOver />
      <PatientFacingRouter embedded={embedded} />
      {!useDemoPane && <MobileSuggestionZoom />}
      {!isProduction() && !embedded && <Footer>{`v${currentVersion}`}</Footer>}
    </>
  );
};
